import { render, staticRenderFns } from "./Dedicacions.vue?vue&type=template&id=c1e49f72&"
import script from "./Dedicacions.vue?vue&type=script&lang=js&"
export * from "./Dedicacions.vue?vue&type=script&lang=js&"
import style0 from "./Dedicacions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports